export const isDateInPast = date => {
	const today = new Date();
	const inputDate = new Date(date);
	return inputDate < today;
};
